import React, {PureComponent, ReactNode} from 'react';

import {Price} from 'components/price/price';

import s from './coverageTable.scss';

type PropsType = {
    phone: string;
    copayPrice: string;
    workingTime: string;
    lensType: string;
    price: number;
    coverageChoice: null | ((place: string) => ReactNode);
};

/**
 * Coverage table which contain fully description of enhanced coverage upsell
 */
export class CoverageTable extends PureComponent<PropsType> {
    /**
     * Render coverage table component
     * @returns {ReactNode} - rendered component
     */
    render(): ReactNode {
        const {copayPrice, coverageChoice, lensType, phone, price, workingTime} = this.props;
        return (
            <table className={s.coverageTable}>
                <colgroup>
                    <col />
                    <col width={360} />
                </colgroup>
                <thead>
                    <tr>
                        <td>We Understand</td>
                        <td>Our Coverage Includes</td>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td className={s.article}>
                            <p>
                                Life isn&apos;t perfect and we understand that things can go away
                                from time to time.
                            </p>
                            <p>Our 20/20 Enhanced Coverage protects you for one year!</p>
                            <p>Return your glasses and get a new pair.</p>
                        </td>
                        <td className={s.article}>
                            <p className={s.checkMark}>
                                Damage from wear and tear
                                <br />
                                <i>“Oh, darn it! ...I scratched my lens”</i>
                            </p>
                            <p className={s.checkMark}>
                                Prescription changes
                                <br />
                                <i>“Hmmm, that&apos;s strange. My prescription seems to be off”</i>
                            </p>
                            <p className={s.checkMark}>
                                Accidental damage from handling
                                <br />
                                <i>“The dog chewed up my glasses...”</i>
                            </p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <ul className={s.cost}>
                                <li className={s.costItem}>
                                    <span className={s.bgCircle} data-test-name="price">
                                        <Price>{price}</Price>
                                    </span>
                                    <p className={s.text}>{lensType}</p>
                                </li>
                            </ul>
                        </td>
                        {coverageChoice && <td>{coverageChoice('Top')}</td>}
                    </tr>

                    <tr>
                        <td colSpan={2}>
                            <h3 className={s.title}>How Does It Work?</h3>
                            <h4 className={s.subtitle}>Here are the answers to your questions :</h4>
                        </td>
                    </tr>

                    <tr className={s.answers}>
                        <td>
                            <p className={s.answer}>
                                So my glasses broke, now what?
                                <br />
                                <i className={s.answerText}>
                                    Just give us a call and we’ll start the exchange process. Within
                                    the first 365 days if your glasses break from normal wear and
                                    tear, you can return your glasses and get a suitable
                                    replacement.
                                </i>
                            </p>

                            <p className={s.answer}>
                                My prescription seems off, can I get new lenses put in?
                                <br />
                                <i className={s.answerText}>
                                    If your eye doctor gave you a new prescription within 365 days
                                    of having purchased from us, just give our expert Customer
                                    Service reps a call and we’ll start the exchange process.
                                    <br />
                                    We can be reached at{' '}
                                    <b className={s.answerImportant}>{phone}</b>
                                    <br />
                                    {workingTime}
                                </i>
                            </p>
                        </td>

                        <td>
                            <p className={s.answer}>
                                How do I send them back?
                                <br />
                                <i className={s.answerText}>
                                    Feel free to send your glasses back through a postal service of
                                    your choice. Make sure to get a tracking number so that we can
                                    see where the glasses are in transit. You will need to supply a
                                    co-pay of <Price>{copayPrice}</Price> for replacement service
                                    (incl. handling)
                                </i>
                            </p>

                            <p className={s.answer}>
                                Where do I send them?
                                <br />
                                <i className={s.answerText}>
                                    <b className={s.answerImportant}>Please ship the glasses to:</b>
                                    <br />
                                    Optimax Fulfillment Services
                                    <br />
                                    c/o Flying Cargo Logistics
                                    <br />
                                    2050 S. Mt Prospect Road STE D
                                    <br />
                                    Des Plaines, Illinois 60018, USA
                                </i>
                            </p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <ul className={s.cost}>
                                <li className={s.costItem}>
                                    <span className={s.bgCircle}>
                                        <Price>{price}</Price>
                                    </span>
                                    <p className={s.text}>{lensType}</p>
                                </li>
                            </ul>
                        </td>
                        {coverageChoice && <td>{coverageChoice('Bottom')}</td>}
                    </tr>
                </tbody>
            </table>
        );
    }
}
